import * as NotificationActions from './notification.reducer'

export const { createNotification, clearNotification } = NotificationActions
